module.exports = __webpack_public_path__ + "img/approved.223efb1e.png";